import { FundClassArgs } from './../../shared/models/fundClassArgs.model';
import { config_url } from './../../config/config_url.constant';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SERVER_API_URL } from 'app/app.constants';
import { Observable } from 'rxjs';
import { Questionnaire } from 'app/shared/models/Questionnaire.modal';
import { TRCAppForm } from 'app/shared/models/tRCAppForm.model';
import { TRCFundClasses } from 'app/shared/models/tRCFundClasses.model';
import { TRCForms } from 'app/shared/models/tRCForms.model';
import { FundClassGridArgs } from 'app/shared/models/fundClassGridArgs.model';


@Injectable({
  providedIn: 'root'
})
export class BussinessRegAppService {

  constructor(private httpClient : HttpClient) { /*empty*/}

  getQuestionGroups() : any {
    return this.httpClient.get(SERVER_API_URL+config_url.QuestionGroups) ;
  }

  getQuestionGrpId(mataName : string) : any {
    return this.httpClient.get(SERVER_API_URL+config_url.GetQuestionGrpId+`${mataName}`) ;
  }

  getQuestionHierarchyWithId(tRCBusGrpId : string) : any{
    return this.httpClient.get(SERVER_API_URL+config_url.QuestionHierarchy+`${tRCBusGrpId}`) ;
  }

  getTRCMaxLevel(tRCBusGrpId : string ) : any {
    return this.httpClient.get(SERVER_API_URL+config_url.getTRCMaxLevel+`${tRCBusGrpId}`)
  }

  getStreetType() : any {
    return this.httpClient.get(SERVER_API_URL+config_url.GetStreetType)
  }

  getUnitType() : any {
    return this.httpClient.get(SERVER_API_URL+config_url.GetUnitType)
  }

  getMiscTypeBusiness() : any {
    return this.httpClient.get(SERVER_API_URL+config_url.GetMiscTypeBusiness)
  }

  getTRCCurrLevel(tRCBusGrpId : string , currLevel : string) : Observable<Questionnaire[]> {
    return this.httpClient.get<Questionnaire[]>(SERVER_API_URL+config_url.getTRCLevel+`${tRCBusGrpId}`+"/"+`${currLevel}`)
  }
  getCurrLvlQuesToDisplay(trcForm : any) : any {
    return this.httpClient.post(SERVER_API_URL+config_url.DisplayCurrLvlQues,trcForm)
  }

  getGrpQuestions(groupId: string): Observable<Questionnaire[]> {
    return this.httpClient.get<Questionnaire[]>(SERVER_API_URL + config_url.GetGrpQuestions + `/${groupId}`);
  }
  getLATAXSSNCnt(ssn: string): any {
    return this.httpClient.get(SERVER_API_URL + config_url.GetLATAXSSNCnt +`${ssn}`);
  }
  getLATAXFEINCnt(fein:string): any {
    return this.httpClient.get(SERVER_API_URL + config_url.GetLATAXFEINCnt +`${fein}`);
  }

  getWebAnswerCnt(questionId:number,answer:string): any {
    return this.httpClient.get(SERVER_API_URL + config_url.GetWebAnswerCnt +`${questionId}/${answer}`);
  }

  getQuestionDetails(tRCBusGrpId : string ) : any {
    return this.httpClient.get(SERVER_API_URL+config_url.QuestionDetails+`${tRCBusGrpId}`);
  }

  getPermitQues(trcForms : TRCForms): Observable<Questionnaire[]> {
    return this.httpClient.post<Questionnaire[]>(SERVER_API_URL + config_url.GetPermitQues,trcForms);
  }

  getSystemDate() : any {
    return this.httpClient.get(SERVER_API_URL+config_url.GetSystemDate,{responseType:'text'})
  }

  getNextGUN(table_name:string,column_Nm:string) : any {
    return this.httpClient.get(SERVER_API_URL+config_url.GetNextGUN+`${table_name}/${column_Nm}`, {responseType : 'text'})
  }

  getNextRegNbr(table_name:string,column_Nm:string) : any {
    return this.httpClient.get(SERVER_API_URL+config_url.GetNextRegNbr+`${table_name}/${column_Nm}`) 
  }

  getCheckDigit(registrationNbr : string , locNbr : string) : any {
    return this.httpClient.get(SERVER_API_URL+config_url.GetCheckDigit+ `${registrationNbr}` +"/"+`${locNbr}`)
  }

  InsEAppRegMaster(trcAppForm : TRCAppForm) : any {
    return this.httpClient.post(SERVER_API_URL+config_url.sp_web_eappreg_data,trcAppForm)
  }

  getDescriptions(fundclses : TRCFundClasses[]) : any {
    return this.httpClient.post(SERVER_API_URL+config_url.GetRevTypeInfo,fundclses)
  }

  getTaxCalInfo(revType : string , dateArg : string ) : any {
    return this.httpClient.get(SERVER_API_URL+config_url.GetTaxCalInfo+ `${revType}` +"/"+`${dateArg}`)
  }

  InsEAppRegDetail(fundClassArgs : FundClassArgs) : any {
    return this.httpClient.post(SERVER_API_URL+config_url.InsEAppRegDetail,fundClassArgs)
  }

  calcTax(revType : string ,measure : number ,effDate : string) : any {
    return this.httpClient.post(SERVER_API_URL+config_url.TaxCalcInitBus +`${revType}`+"/"+`${measure}`+"/"+`${effDate}`,{})
  }

  proRateCalculation(taxAmt : number, effDate : string , periodEndDate : string , periodType : string) : any {
    return this.httpClient.get(SERVER_API_URL+config_url.TaxCalcPeriodType+ `${taxAmt}` +"/"+`${effDate}`+"/"+`${periodEndDate}`+"/"+`${periodType}`)
  }

  insWeb(data:any):any{
    return this.httpClient.post(SERVER_API_URL + config_url.InsWeb, data)
  }

  insWebRnw(data:any):any{
      return this.httpClient.post(SERVER_API_URL + config_url.InsWebRnw, data)
  }
  
  setAnswers(data : any ) : any{
    return this.httpClient.post(SERVER_API_URL+config_url.Answers , data);
  }
 
  InsWebLogon(data : any) : any {
    return this.httpClient.post(SERVER_API_URL + config_url.webLogon,data);
  }

  updateWebTaxPayer(strTaxPayerLogOnID:string,strPageVisited:string) : any {
    return this.httpClient.post(SERVER_API_URL+config_url.UpdateWebTaxPayer+`/${strTaxPayerLogOnID}/${strPageVisited}` , {});
  }

  updateWebTaxPayerUsingWebFiling(strWebFilingID:string,strPageVisited:string) : any {
    return this.httpClient.post(SERVER_API_URL+config_url.UpdateWebTaxPayerUsingWebFiling+`/${strWebFilingID}/${strPageVisited}` , {});
  }

  matchAddressExact(trcAppForm : any) : any {
    return this.httpClient.post(SERVER_API_URL+config_url.matchExactAddress,trcAppForm)
  }

  matchAddressFuzzy(trcAppForm : any) : any {
    return this.httpClient.post(SERVER_API_URL+config_url.matchFuzzyAddress,trcAppForm, {responseType : 'text'})
  }

  getSystemParam(data: string): any {
    return this.httpClient.get(SERVER_API_URL + config_url.GetSystemParm + `${data}`) ;
  }
  getpreviewdata(data: any) :any{
    return this.httpClient.post(SERVER_API_URL + config_url.Previewdata, data, {responseType : 'text'});	
 }
 sendReceiptEmail(data : any) : any {
  return this.httpClient.post(SERVER_API_URL+config_url.SendReceiptEmail , data)
}

getStates():any{
  return this.httpClient.get(SERVER_API_URL+ config_url.GetStates)
}
getNAICS(data:any):any{
  return this.httpClient.post(SERVER_API_URL+ config_url.GetNAICS, data)
}

updateTrcSessionForm(uTrcFormData:any):any{
  return this.httpClient.post(SERVER_API_URL+ config_url.UpdateTrcSessionForm, uTrcFormData)
}

saveAllData(data:any):any{
  return this.httpClient.post(SERVER_API_URL+config_url.SaveAllData , data)
}
getFundClassMeasureGrid(fundClassGridArgs : FundClassGridArgs ):any{
  return this.httpClient.post(SERVER_API_URL+config_url.MeasureGrid , fundClassGridArgs)
}
getTRCCurrLevelQues(tRCBusGrpId : string , currLevel : string,questionId:number) : Observable<Questionnaire[]> {
    return this.httpClient.get<Questionnaire[]>(SERVER_API_URL+config_url.getTRCLevelQues+`${tRCBusGrpId}`+"/"+`${currLevel}`+"/"+`${questionId}`)
    }
getTRCCurrFCLevelQues(tRCBusGrpId : string , currLevel : string,questionIds:number[]) : Observable<Questionnaire[]> {
    return this.httpClient.post<Questionnaire[]>(SERVER_API_URL+config_url.getTRCFCLevelQues+`${tRCBusGrpId}`+"/"+`${currLevel}`,questionIds)
    }
getTRCFastTrackQues(tRCFastTrackGrpId : string , currLevel : string,questionIds:number[]) : Observable<Questionnaire[]> {
    return this.httpClient.post<Questionnaire[]>(SERVER_API_URL+config_url.getTRCLevelQues+`${tRCFastTrackGrpId}`+"/"+`${currLevel}`,questionIds)
    }
}

